export default function reducer(state = {
  sucursalesFE: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_FE": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}